// extracted by mini-css-extract-plugin
export var cell = "_4u-4";
export var headerCell = "_4u-2";
export var rowHeader = "_4u-3";
export var table = "_4u-1";
export var tableContainer = "_4u-0";